import React from 'react';

import { HeaderGroup, flexRender } from '@tanstack/react-table';

import { TUseReactTableState } from 'hooks/useReactTableState';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import classes from 'components/common/Tables/TableV8/components/Header/Header.module.scss';
import { Filter } from 'components/common/Tables/TableV8/components/Header/components/Filter/Filter';

interface Props extends Partial<TUseReactTableState> {
    headerGroup: HeaderGroup<any>;
    className?: string;
}

export const Header = ({ headerGroup, className }: Props) => {
    return (
        <div>
            <div data-testid={'table-header-row'} className={`${classes.headerRow} ${className ? className : ''} `}>
                {headerGroup.headers.map((header) => {
                    const sortDirection = header.column.getIsSorted() || '';
                    return (
                        <div
                            data-testid={'header-cell'}
                            key={header.id}
                            style={{
                                width: header.getSize() !== 0 ? header.getSize() : 150,
                                flex: header.column.columnDef.meta?.isFixedSize ? 'none' : `${header.getSize()} 0 auto`,
                            }}
                            className={classes.headerCell}
                        >
                            {header.isPlaceholder ? null : (
                                <>
                                    <div
                                        data-testid={'can-sort'}
                                        className={header.column.getCanSort() ? classes.canSort : ''}
                                        onClick={header.column.getToggleSortingHandler()}
                                    >
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                        <span className={`${classes.sort} ${classes[sortDirection]}`}>
                                            {header.column.getIsSorted() && (
                                                <CustomizedTooltip
                                                    tooltipPosition={TooltipPosition.Top}
                                                    tooltipContent={'Toggle Sort By'}
                                                    triggerElement={
                                                        <Icon name={'arrow_up'} size={'2.4rem'} color={'#fff'} />
                                                    }
                                                />
                                            )}
                                        </span>
                                    </div>
                                    <div>
                                        {header.column.getCanFilter() ? (
                                            <div>
                                                <Filter column={header.column} />
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
